import React from 'react';
import { Stack } from '../../../../../components/Stack/Stack';
import { loadAllocations } from '../../../../../model/contingent';
import { useAsync } from '../../../../../model/data';
import { Event, useEventSalesStatusPolling } from '../../../../../model/event';
import { loadVenuePlan } from '../../../../../model/venue';
import { useErrorHandler } from '../../../../../util/react-util';
import './../Event.css';
import { AllocationList } from './AllocationList';
import { AllocationMap } from './AllocationMap';
import { GeneralAdmissionAllocation } from './GeneralAdmissionAllocation';
import { Overview } from './overview';
import { SaleStats } from './SaleStats';

export function Contingent({ event }: { event: Event }): JSX.Element {
  const [, venuePlanError] = useAsync(() => loadVenuePlan(event));
  const [, allocationsError] = useAsync(() => loadAllocations(event));
  useErrorHandler(venuePlanError);
  useErrorHandler(allocationsError);
  useEventSalesStatusPolling(event.id, { start: true });

  const usePlan = event.venueLayout.requiresMapSelection;
  const singleAdmissionSection = !usePlan && event.venuePlan?.sections?.[0];

  return (
    <Stack size="lg">
      <Overview id={event.id} />
      {usePlan && <AllocationMap event={event} />}
      {singleAdmissionSection && <GeneralAdmissionAllocation event={event} section={singleAdmissionSection} />}
      <AllocationList event={event} />
      <SaleStats event={event} />
    </Stack>
  );
}
